import React, { ForwardedRef } from "react";
import clsx from "clsx";

import styles from "./Form.module.scss";

export interface FormInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  type?: React.HTMLInputTypeAttribute;
}

export const FormInput = React.forwardRef(
  (
    { name, type = "text", ...rest }: FormInputProps,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    return (
      <div className={clsx(styles["ap-form-input"], "form-element__control")}>
        <input ref={ref} type={type} className="text-input" {...rest} />
      </div>
    );
  }
);
